import axios from './BaseService';

const SENTIMENT_URL = `${process.env.REACT_APP_API_URL}/sentiment`;

const locale = () => localStorage.getItem('goldhub_locale') || 'en';

export async function getSentiment(symbol = 'BNB') {
    const response = await axios.get(`${SENTIMENT_URL}?symbol=${symbol}&locale=${locale()}`);
    return response.data;
}

export async function getSentimentHistory(symbol = 'BNB', page = 1) {
    const response = await axios.get(`${SENTIMENT_URL}/history?symbol=${symbol}&page=${page}`);
    return response.data;
}
